export enum FilterToHeader {
  TITLE = 'TÍTULO',
  AUTHOR = 'AUTOR(A)',
  DELIVERY_DATE = 'DATA ENTREGA',
  PUBLICATION_DATE = 'DATA PUBLICAÇÃO',
  GRADE = 'NOTA',
  STATUS = 'STATUS',
}
